import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import Button from "../../components/Button";
import { CircularProgress } from "@mui/material";
import { RouteConstants } from "../../helpers/RouteConstants";
import ShowToast from "../../components/alerts/all_toasts";
import BaseService from "../../helpers/baseServices";
import { PhoneInput } from "react-international-phone";
import { persistAuthV2Session } from "../../helpers/authSession";
import OtpVerifyStep from "../../components/auth/OtpVerifyStep";

const ForgotPin = () => {
  const [step, setStep] = useState<number>(1);
  const [isError, setIsError] = useState(false);
  const [phone, setPhone] = useState("");
  const [isBusy, setIsBusy] = useState(false);
  const navigate = useNavigate();

  const submitResetRequest = async () => {
    const formatPhoneNumber = phone?.replace(/\s+/g, "");
    if (!phone) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsBusy(true);
    try {
      await BaseService.post_api(RouteConstants.PASSWORD_RESET_REQUEST, {
        identifier: formatPhoneNumber,
      });
      ShowToast.success_toast("Verification code sent");
      setStep(2);
    } catch (error: any) {
      ShowToast.error_toast(error?.response?.data?.message);
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <Fragment>
      <div className="h-screen bg-neutral-50 overflow-hidden flex flex-col">
        <div className="w-full px-[20px] mt-[20%]">
          {step === 1 && (
            <div>
              <button onClick={() => navigate("/")}>
                <ChevronLeftIcon className="w-6 h-6" />
              </button>
              <div className="header-text-3 mt-8">Forgot password</div>
              <div className="body-text-2 pt-1">
                Enter your phone number linked to your account.
              </div>
              <div className="flex flex-col mt-8 relative">
                <small className={`${isError ? "text-red-500" : ""} mb-2 ml-1`}>
                  Your mobile number
                </small>
                <PhoneInput
                  inputClassName="input"
                  defaultCountry="gh"
                  hideDropdown
                  placeholder="Enter your phone number"
                  inputStyle={{
                    width: "100%",
                    height: "50px",
                    fontSize: "18px",
                    border: "1px solid #939291",
                    padding: "8px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  value={phone}
                  onChange={(value: any) => setPhone(value)}
                  disabled={isBusy}
                />
              </div>
              <div className="mt-[50px] flex justify-center items-center">
                <Button
                  width="w-full flex justify-center"
                  onClick={() => submitResetRequest()}
                >
                  {isBusy ? (
                    <CircularProgress size={24} sx={{ color: "red" }} />
                  ) : (
                    <span>Continue</span>
                  )}
                </Button>
              </div>
            </div>
          )}

          {step === 2 && (
            <OtpVerifyStep
              identifier={phone?.replace(/\s+/g, "")}
              purpose="PASSWORD_RESET"
              title="Reset password"
              subtitle={`Enter the code sent to ${phone} and choose a new password.`}
              submitLabel="Reset password"
              onBack={() => setStep(1)}
              onSuccess={(payload) => {
                ShowToast.success_toast("Password reset. You're signed in.");
                persistAuthV2Session(payload);
                navigate("/home", { replace: true });
              }}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPin;
